import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import { isUndefined } from "@/shared/FunctionCore";

type IBreadcrumb = {
	name: string,
	url?: string,
	useAnchorTag?: boolean
}
interface IBreadcrumbProps {
	breadcrumbs: IBreadcrumb[],
	forComponent: string,
	delimiter?: string,
	styling?: string
}

const Breadcrumb = ({ breadcrumbs, forComponent, delimiter, styling }: IBreadcrumbProps): JSX.Element => {
	const delimiterSymbol = delimiter || "/";
	function capitalizeFirstLetters(name) {
		return name.split(' ')
				   .map(word => word.charAt(0).toUpperCase() + word.slice(1))
				   .join(' ');
	}
	const renderCrumbs = () => (
		<ol className="breadcrumb">
			{breadcrumbs.map((item, index) => (
				<span key={`breadcrumb-${index}`}>
					<span>
						{index !== 0 && (
							<span aria-hidden="true" className={classNames({
								"delimiter": true,
								"px-1": forComponent === "SearchResult",
								"px-3": forComponent === "businessDirectory",
								"padding-lr-3": forComponent === "contactDirectory"
							})}>
								{delimiterSymbol}
							</span>
						)}
						{isUndefined(item.url) || item.url === '' ?
							<span
								aria-current="page"
								className={`breadcrumbItem breadcrumbItemDisable ${styling} ${item?.style}`}
							>
								{capitalizeFirstLetters(item.name)}
							</span> : (
								item?.useAnchorTag ? 
								<a href={item.url}>
									<span className={`breadcrumbItem ${styling}`}>
										{capitalizeFirstLetters(item.name)}
									</span>
								</a> 
								:
								<Link to={item.url}>
									<span className={`breadcrumbItem ${styling}`}>
										{capitalizeFirstLetters(item.name)}
									</span>
								</Link>
						)}
					</span>
				</span>
			))}
		</ol>
	)

	if (["businessDirectory", "SearchResult", "contactDirectory", "contactProfile", "contactIndustryPage"].includes(forComponent)) {
		return (
			<div className={classNames({
				// "breadcrumbWrapper": forComponent !== "contactProfile",
				"breadcrumbWrapper": true,
				"pl-75": forComponent === "SearchResult",
				"contact-breadcrumb": forComponent === "contactProfile",
				"contact-industry-breadcrumb-wrapper": forComponent === "contactIndustryPage"
			})}
			>
				<nav aria-label="breadcrumb">
					{renderCrumbs()}
				</nav>
			</div>
		)
	}

	// else overview component
	return (
		<div className="component-wrapper">
			<div
				className={classNames({
					"col-md-12 col-xs-12 wrapper clearfix": true,
					"company_profile_breadcrumb_wrapper": forComponent === "companyProfile"
				})}
				>
				<div>
					<div className="previous-button">
						{/* <a className="prev-btn" aria-label="GYEONGGI"
								href="/business-directory/company-information.semiconductor_and_other_electronic_component_manufacturing.kr.gyeonggi.html">	
							</a> */}
					</div>
					{renderCrumbs()}
				</div>
			</div>
		</div>
	)
}
export default Breadcrumb;

